<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Publishing Club Directory</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.list_office_bearers"
              label="List Of Office Bearers"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.details_of_members"
              label="Details Of Members"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.board_meetings_schedule"
              label="Board Meetings Schedule"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.regular_meetings_schedule"
              label="Regular Meetings Schedules"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.committee_structure"
              label="Committee Structure"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.project_proposal"
              label="Project Proposal "
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.electronic"
              label="Electronic media (electronic) "
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.printing"
              label="Printing media"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of proof 01"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of proof 02"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.list_office_bearers"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "PublishingClubDirectory",

  components: { Alert },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      list_office_bearers: 0,
      date: null,
      details_of_members: 0,
      regular_meetings_schedule: 0,
      board_meetings_schedule: 0,
      committee_structure: 0,
      project_proposal: 0,
      electronic: 0,
      printing: 0,
      document1: null,
    },

    url: "publishing-club-directories",
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();

      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);

      fd.append("list_office_bearers", this.form.list_office_bearers == null ? 0 : this.form.list_office_bearers);
      fd.append("date", this.form.date);
      fd.append("details_of_members", this.form.details_of_members == null ? 0 : this.form.details_of_members);
      fd.append("board_meetings_schedule", this.form.board_meetings_schedule == null ? 0 : this.form.board_meetings_schedule);
      fd.append(
        "regular_meetings_schedule",
        this.form.regular_meetings_schedule == null ? 0 : this.form.regular_meetings_schedule
      );
      fd.append("committee_structure", this.form.committee_structure == null ? 0 : this.form.committee_structure);
      fd.append("project_proposal", this.form.project_proposal == null ? 0 : this.form.project_proposal);
      fd.append("month", this.$route.params.month);
      fd.append("electronic", this.form.electronic == null ? 0 : this.form.electronic);
      fd.append("printing", this.form.printing == null ? 0 : this.form.printing);
      fd.append("key", "PUBLISHING_CLUB_DIRECTOR");

      let data = fd;
      ActivityService.submitActivity(this.url, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
